import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section aria-labelledby="faq-title" className="bg-cream px-5 py-20 md:py-28" data-id="element-56" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-57" data-mp="2bkm6r29brfcd">
        <h2 id="faq-title" className="text-center text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-58" data-mp="2bkvx4qya7oil">
          Frequently Asked Questions
        </h2>
        <div className="mt-12 space-y-3" data-id="element-59" data-mp="21v2lxr21xbev">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-card bg-white shadow-card" data-id="element-60" data-mp="2ui6ta2oma1tt" data-mpi={index}>
                <h3 data-id="element-61" data-mp="2zazxmpg6b85d">
                  <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-sm font-bold text-pine transition-colors duration-150 ease-out hover:text-pine-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber md:px-6 md:text-base" data-id="element-62" data-mp="2zbhqrd7jh692">
                    {question}
                    {open ? <MinusIcon className="h-5 w-5 shrink-0 text-turquoise" aria-hidden="true" data-id="element-63" data-mp="2agrtlv1efyw9" /> : <PlusIcon className="h-5 w-5 shrink-0 text-turquoise" aria-hidden="true" data-id="element-64" data-mp="2jfln3cjfo95l" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-65" data-mp="u0nuugjii0fl">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-66" data-mp="p2vs0rhbwtwm">
                      <p className="px-5 pb-6 text-sm leading-relaxed text-slate-body md:px-6" data-id="element-67" data-mp="334ehtdok5oj0">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}